import { render, staticRenderFns } from "./GroupSalesmanTable.vue?vue&type=template&id=18a4c433&scoped=true"
import script from "./GroupSalesmanTable.vue?vue&type=script&lang=js"
export * from "./GroupSalesmanTable.vue?vue&type=script&lang=js"
import style0 from "./GroupSalesmanTable.vue?vue&type=style&index=0&id=18a4c433&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a4c433",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a4c433')) {
      api.createRecord('18a4c433', component.options)
    } else {
      api.reload('18a4c433', component.options)
    }
    module.hot.accept("./GroupSalesmanTable.vue?vue&type=template&id=18a4c433&scoped=true", function () {
      api.rerender('18a4c433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/taxPaymentReceipt/components/GroupSalesmanTable.vue"
export default component.exports